export default __webpack_public_path__ + "static/media/banner.5434c23d.png";